// extracted by mini-css-extract-plugin
module.exports = {"finance":"finance-3cHnlgsh"};